import { c as _c } from "react/compiler-runtime";
import React, { forwardRef, useState } from 'react';
import { Button, Text } from '@chakra-ui/react';
import { DialogBody, DialogCloseTrigger, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle } from '@/components/ui/dialog';
import { NativeSelectField, NativeSelectRoot } from '@/components/ui/native-select';
import { InferenceAlgorithm } from '@/services/bayesianApi/models';
export type InferenceAlgorithmModalProps = {
  networkName: string;
  availableAlgorithms: InferenceAlgorithm[];
  currentAlgorithm: InferenceAlgorithm;
  onAlgorithmChange: (algorithm: InferenceAlgorithm) => unknown;
  onClose: () => void;
  isOpen: boolean;
};
const InferenceAlgorithmModal = forwardRef<HTMLDivElement, InferenceAlgorithmModalProps>((t0, ref) => {
  const $ = _c(36);
  const {
    networkName,
    availableAlgorithms,
    currentAlgorithm,
    onAlgorithmChange,
    onClose,
    isOpen
  } = t0;
  const [selectedAlgorithm, setSelectedAlgorithm] = useState(currentAlgorithm);
  let t1;
  if ($[0] !== onClose) {
    t1 = e => !e.open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== networkName) {
    t2 = <DialogTitle>Select Inference Algorithm - {networkName}</DialogTitle>;
    $[2] = networkName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogCloseTrigger />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <DialogHeader>{t2}{t3}</DialogHeader>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = ` ${currentAlgorithm}`;
  let t6;
  if ($[7] !== t5) {
    t6 = <Text as="div" color="gray.600" mb={2}>Current algorithm:{t5}</Text>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setSelectedAlgorithm(e_0.target.value as InferenceAlgorithm);
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== availableAlgorithms) {
    t8 = availableAlgorithms.map(_temp);
    $[10] = availableAlgorithms;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== selectedAlgorithm || $[13] !== t8) {
    t9 = <NativeSelectRoot><NativeSelectField value={selectedAlgorithm} onChange={t7}>{t8}</NativeSelectField></NativeSelectRoot>;
    $[12] = selectedAlgorithm;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <DialogBody>{t6}{t9}</DialogBody>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onClose) {
    t11 = <Button mr={3} variant="ghost" onClick={onClose}>Cancel</Button>;
    $[18] = onClose;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== onAlgorithmChange || $[21] !== onClose || $[22] !== selectedAlgorithm) {
    t12 = <Button colorScheme="blue" onClick={() => {
      onAlgorithmChange(selectedAlgorithm);
      onClose();
    }}>Save</Button>;
    $[20] = onAlgorithmChange;
    $[21] = onClose;
    $[22] = selectedAlgorithm;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <DialogFooter>{t11}{t12}</DialogFooter>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== ref || $[28] !== t10 || $[29] !== t13 || $[30] !== t4) {
    t14 = <DialogContent ref={ref}>{t4}{t10}{t13}</DialogContent>;
    $[27] = ref;
    $[28] = t10;
    $[29] = t13;
    $[30] = t4;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isOpen || $[33] !== t1 || $[34] !== t14) {
    t15 = <DialogRoot open={isOpen} onOpenChange={t1}>{t14}</DialogRoot>;
    $[32] = isOpen;
    $[33] = t1;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
});
InferenceAlgorithmModal.displayName = 'InferenceAlgorithmModal';
export default InferenceAlgorithmModal;
function _temp(algorithm) {
  return <option key={algorithm} value={algorithm}>{algorithm}</option>;
}